import axios from "axios";

// Default values for all axios requests
axios.defaults.withCredentials = true;
axios.defaults.validateStatus = (status) => status < 300;
axios.defaults.timeout = 30 * 1000; // 10 seconds
